import {get, map, filter, isEmpty} from 'lodash';
import { loadScriptInHeadImmediately } from '../../utils/dom';
import { EDITION_ID_TO_CHARTBEAT_DOMAIN } from '../../constants';

export default function setupChartbeat(edition_data, onProduction) {
  window._sf_async_config = window._sf_async_config || {};

  window._cbq = window._cbq || [];
  window._sf_endpt=(new Date()).getTime();

  const scriptRoot = 'https://static.chartbeat.com';

  const chartbeatDomain = onProduction
    ? EDITION_ID_TO_CHARTBEAT_DOMAIN[edition_data.id]
    : 'refinery29.dev';

  window._sf_async_config.uid = 3552;
  window._sf_async_config.domain = chartbeatDomain;
  window._sf_async_config.useCanonical = true;
  window._sf_async_config.ytApikey = "AIzaSyBI1jNLysN4k_JCp-BoqiB8V_qkH1znvW";
  window._sf_async_config.flickerControl = false;
  window._sf_async_config.useCanonicalDomain = true;

  /*
   *  Normally Youtube tracking would be done here, but it is not.
   *  That is done in youtube.js now.
   *
   *  Bug: https://refinery29.atlassian.net/browse/ME-164
   *  Fix: https://refinery29.atlassian.net/browse/ME-322
   *
   */

  loadScriptInHeadImmediately('statistics', `${scriptRoot}/js/chartbeat_mab.js`);
  loadScriptInHeadImmediately('statistics', `${scriptRoot}/js/chartbeat_video.js`);
}

export function updateChartbeatConfig({ ads, article }) {
  window._sf_async_config.sponsorName = get(ads, 'ad_data.ad_sponsorship');

  if (!isEmpty(article)) {
    const primarySlug = get(article, 'primary_category.slug');
    const parentSlug = get(article, 'primary_category.parent.slug');
    const authors = filter(article.bylines, 'featured');

    window._cbq.push(['_demo', `aid=${article.id}`]);
    window._sf_async_config.title = article.title;
    window._sf_async_config.authors = map(authors, 'name').join(', ');
    window._sf_async_config.sections = `${primarySlug}, ${parentSlug}`;
  } else {
    window._sf_async_config.sections = 'Refinery29';
  }
}
